import { ChangeDetectorRef, Component, Input } from "@angular/core";
import { DatesAreSame, ToISOString } from "@helpers/dateHelper";
import { HeatMapDayData } from "@interfaces/heatMapDayData.interface";

type DayCell = {
	backgroundColour: string;
	date: Date;
	dateISO: string;
	details: string;
	isActive: boolean;
	isCurrentMonth: boolean;
	isToday: boolean;
	isWeekend: boolean;
};

type MonthBlock = {
	label: string;          // 'JAN', 'FEB', ...
	monthIndex: number;     // 0-11
	weeks: DayCell[][];     // weeks[weekIdx][weekdayIdx 0..6]
	year: number;
};

@Component({
	moduleId: module.id,
	selector: "heatMap",
	styleUrls: ["heatMap.css"],
	templateUrl: "heatMap.html"
})

export class HeatMapComponent {	
	@Input() heatMapDayData!: HeatMapDayData[];
	@Input() heatMapFromDate!: Date;
	@Input() heatMapToDate!: Date;

	loading = true;
	months: MonthBlock[] = [];
	prevLength = 0;

	constructor(private cdRef: ChangeDetectorRef) {}

	buildMonths() {
		if (this.heatMapDayData === null || this.heatMapFromDate === null || this.heatMapToDate === null || this.heatMapDayData === undefined || this.heatMapFromDate === undefined || this.heatMapToDate === undefined) {
			return;
		}

		const months: MonthBlock[] = [];
		const from = this.heatMapFromDate;
		const to = this.heatMapToDate;
		const cursor = new Date(from.getFullYear(), from.getMonth(), 1);
		while (cursor <= to) {
			const year = cursor.getFullYear();
			const monthIndex = cursor.getMonth();

			const first = new Date(year, monthIndex, 1);
			const last = new Date(year, monthIndex + 1, 0);

			// pad to Monday-start week block
			const padStart = (first.getDay() + 6) % 7; // 0 for Mon ... 6 for Sun
			const padEnd = (7 - ((last.getDay() + 6) % 7) - 1 + 7) % 7;

			const startDate = new Date(first);
			startDate.setDate(first.getDate() - padStart);

			const endDate = new Date(last);
			endDate.setDate(last.getDate() + padEnd);

			const cells: DayCell[] = [];
			for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
				const cellDate = new Date(d);
				const isCurrentMonth = cellDate.getMonth() === monthIndex;
				const dateISO = ToISOString(cellDate);
				const isToday = DatesAreSame(cellDate, new Date());
				const dow = (cellDate.getDay() + 6) % 7; // Mon=0
				const heatMapDayData = this.heatMapDayData.filter((d: HeatMapDayData) => d.dateString === dateISO);
				const isActive = heatMapDayData.length > 0;
				const backgroundColour = heatMapDayData.length > 0 && isCurrentMonth === true ? heatMapDayData[0].backgroundColour : "";
				const details = heatMapDayData.length > 0 ? heatMapDayData[0].details : "";

				cells.push({
					backgroundColour: backgroundColour,
					date: cellDate,
					dateISO: dateISO,
					details: isCurrentMonth ? dateISO + (details.length > 0 ? " - " + details : "") : "",
					isActive,
					isCurrentMonth: isCurrentMonth,
					isToday,
					isWeekend: dow >= 5
				});
			}

			// chunk into weeks (columns are weeks, each week has 7 rows)
			const weeks: DayCell[][] = [];
			for (let i = 0; i < cells.length; i += 7) {
				weeks.push(cells.slice(i, i + 7));
			}

			months.push({
				label: first.toLocaleString(undefined, { month: "short" }).toUpperCase(),
				monthIndex,
				weeks,
				year,
			});

			// advance 1 month
			cursor.setMonth(cursor.getMonth() + 1);
		}
		this.months = months;
	}

	ngDoCheck() {
		if (this.heatMapDayData !== null && this.heatMapDayData.length !== this.prevLength) {
			this.prevLength = this.heatMapDayData.length;
			this.cdRef.markForCheck();
			//alert("Loaded HeatMap");
			this.buildMonths();
		}
	}
}